import Vue from 'vue'

import providerTransformer from './../../transformers/provider/'

export default (id) => {
  return Vue.$http.get(`catalogs/providers/${id}/`)
    .then(response => {
      return providerTransformer.fetch(response.data)
    })
}


// WEBPACK FOOTER //
// ./src/services/provider/fetchProviderInfo.js